import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import DashboardPage from './views/DashboardPage';
import CarsPage from './views/CarsPage';
// import CarDetailsPage from './views/CarDetailsPage';
import CustomersPage from './views/CustomersPage';
import RentalsPage from './views/RentalsPage';
import ExpensesPage from './views/ExpensesPage';
import CalendarPage from './views/CalendarPage';
import ReportsPage from './views/ReportsPage';
import UsersPage from './views/UsersPage'; // ⬅️ Добавь это
import LoginPage from './views/LoginPage';

function RequireAuth({ children }) {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <App />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="cars" element={<CarsPage />} />
          {/* <Route path="cars/:id" element={<CarDetailsPage />} /> */}
          <Route path="customers" element={<CustomersPage />} />
          <Route path="rentals" element={<RentalsPage />} />
          <Route path="expenses" element={<ExpensesPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="users" element={<UsersPage />} /> {/* ⬅️ Добавь это */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}